export default "__VITE_ASSET__Cvy29M5z__ 300w";